import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";

// Push runs in the iOS Firebase project, so messaging needs its own app beside the Remote Config one.
export const messagingConfig = {
    apiKey: process.env.REACT_APP_FCM_API_KEY,
    authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FCM_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FCM_SENDER_ID,
    appId: process.env.REACT_APP_FCM_APP_ID,
};

export const FCM_VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;

let messagingPromise = null;

// Safari below 16.4 and anything without a service worker resolve to null instead of throwing.
export const getMessagingIfSupported = () => {
    if (!messagingPromise) {
        messagingPromise = isSupported()
            .then((supported) => (supported ? getMessaging(initializeApp(messagingConfig, "messaging")) : null))
            .catch(() => null);
    }

    return messagingPromise;
};
